import { render } from "./LoginPage2.vue?vue&type=template&id=4e18a2df"
import script from "./LoginPage2.vue?vue&type=script&lang=js"
export * from "./LoginPage2.vue?vue&type=script&lang=js"

import exportComponent from "/opt/doctorsp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__